import { Suspense } from 'react'
import { Redirect, Route, Switch } from 'wouter'
import { Spin } from 'antd'
import { appRoutes } from '@/app/routes'
import { RequireAuth, RequirePermission } from '@/app/AccessGuard'
import { RouteFocus } from '@/app/RouteFocus'
import { AdminShell } from '@/layout/AdminShell'
import LoginPage from '@/features/auth/LoginPage'
import { RouteNavigationProvider } from '@/app/navigation'
import { RouteErrorBoundary } from '@/app/RouteErrorBoundary'

function LoadingPage() {
  return <div className="route-loading" role="status"><Spin size="large" tip="正在加载页面" /></div>
}

export function AppRouter() {
  return (
    <>
      <RouteNavigationProvider />
      <RouteFocus />
      <Switch>
        <Route path="/login"><LoginPage /></Route>
        {appRoutes.map(({ path, component: Component, permission }) => (
          <Route key={path} path={path}>
            <RequireAuth>
              <AdminShell>
                <RouteErrorBoundary><RequirePermission permission={permission}><Suspense fallback={<LoadingPage />}><Component /></Suspense></RequirePermission></RouteErrorBoundary>
              </AdminShell>
            </RequireAuth>
          </Route>
        ))}
        <Route><Redirect to="/" replace /></Route>
      </Switch>
    </>
  )
}
